import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { getTopic } from "@store/action/smartend/TopicAction";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: true,
};

const Partener = ({ t }) => {
  const store = useSelector((state) => state.NewsReducer);
  const news = store?.data;
  const dispatch = useDispatch();
  const webmasterTitle = "Partners";
  useEffect(() => {
    dispatch(
      getTopic(webmasterTitle, {
        page: 1,
        per_page: 500,
      })
    );
  }, [dispatch]);

  return (
    <div>
      <section className="section sponsor-part">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-heading">
                <h2>{t("Our Partner")}</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="center">
                <Swiper {...params}>
                  {news.data?.length &&
                    news?.data.map((item) => (
                      <SwiperSlide>
                        <a>
                          <img
                            width="250px"
                            height="250px"
                            src={item.photo_file && item.photo_file}
                            alt={`${item.title}-${item.id}`}
                            style={{ objectFit: "contain" }}
                          />
                          <center
                            style={{
                              marginRight: "40px",
                            }}
                          >
                            {item.title}
                          </center>
                        </a>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="intro-part">
        <div className="container__video">
          <div className="row">
            <div className="col-lg-12">
              <div className="intro-content">
                <h1>{t("Become a Our Sponsorship")}</h1>
                <p>
                  {t("Support our web radio and reach a diverse audience.")}
                  <br />
                  <b>
                    {t(
                      "Partner with us to bring quality programming to listeners worldwide."
                    )}
                  </b>
                </p>
                <Link to="/contact-us" className="btn btn-inline">
                  <i className="fa fa-external-link me-1"></i>
                  <span>{t("Contact us")}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partener;
